import Maintenance from '@/views/Maintenance.vue'

export default {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
}
